// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignUpButton_container__uNems {
    padding: 8px 20px;
    background: #43a047;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
    font-weight: bold;
}
.SignUpButton_container__uNems:hover {
    background: #2e7d32;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SignUpButton/SignUpButton.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".container {\r\n    padding: 8px 20px;\r\n    background: #43a047;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n    font-weight: bold;\r\n}\r\n.container:hover {\r\n    background: #2e7d32;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SignUpButton_container__uNems`
};
export default ___CSS_LOADER_EXPORT___;
